export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20flat%20lay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20orange%20hoodie%20denim%20jacket%20leather%20bag%20baseball%20cap%20and%20sunglasses%20artistically%20arranged%20on%20warm%20terracotta%20and%20sand%20textured%20surface%2C%20bright%20natural%20sunlight%20from%20left%2C%20deep%20rich%20shadows%2C%20lifestyle%20editorial%20photography%2C%20high%20contrast%20warm%20earthy%20color%20palette%2C%20professional%20fashion%20magazine%20quality&width=1800&height=900&seq=hero-bg-v2-litbuy&orientation=landscape"
          alt="LitBuy Spreadsheet fashion product collection background"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 py-20 md:py-24">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              LitBuy Spreadsheet
              <br />
              <span className="text-accent-300">Resources &amp; Guides</span>
              <br />
              <span className="text-white/80 text-2xl md:text-3xl lg:text-4xl font-normal">
                For Smart Shopping
              </span>
            </h1>

            <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-8 md:gap-16">
              <p className="text-white/85 text-base md:text-lg max-w-xs leading-relaxed">
                15+ Product Categories. SEO-optimized data for modern buyers seeking the best deals and product insights.
              </p>
              <p className="text-white/85 text-base md:text-lg max-w-xs leading-relaxed">
                Visit Kaspreadsheet for the full product catalog. Browse thousands of items across every category.
              </p>
            </div>

            <div className="mt-8 md:mt-10 flex flex-wrap gap-4">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                litbuy spreadsheet
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line"></i></span>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 bg-white text-foreground-900 px-6 py-3 rounded-full text-sm font-semibold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                Explore More
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}